import { qcAxios } from '../../../../../api/axiosQcClient';

const API_PREFIX = '/api';
const VIEW = 'REVIEWER';

function normalizeBatchList(payload) {
  const items = payload?.data?.data;
  if (!Array.isArray(items)) return [];
  return items.filter((item) => Boolean(item?.batch_id));
}

export async function getUserBatches({ workflowId, reqStatus }) {
  const { data } = await qcAxios.get(`${API_PREFIX}/batchData/getUserBatches`, {
    params: {
      workflow_id: workflowId,
      reqStatus,
      view: VIEW,
    },
  });
  return normalizeBatchList(data);
}
